import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link to="/" className="navbar-logo">
          🎳 <span>SkyLanes</span>
        </Link>
        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/parties-events" onClick={() => setMenuOpen(false)}>Parties & Events</Link>
          {isHome ? (
            <>
              <a href="#hours" onClick={() => setMenuOpen(false)}>Hours</a>
              <a href="#about" onClick={() => setMenuOpen(false)}>About Us</a>
            </>
          ) : (
            <>
              <Link to="/#hours" onClick={() => setMenuOpen(false)}>Hours</Link>
              <Link to="/#about" onClick={() => setMenuOpen(false)}>About Us</Link>
            </>
          )}
        </div>
        <button
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
